import { render, staticRenderFns } from "./booking-create-header-v2.vue?vue&type=template&id=58ab7936&scoped=true&"
import script from "./booking-create-header-v2.vue?vue&type=script&lang=js&"
export * from "./booking-create-header-v2.vue?vue&type=script&lang=js&"
import style0 from "./booking-create-header-v2.vue?vue&type=style&index=0&id=58ab7936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab7936",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
